package com.anjuros.website.templates.selection.modules

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColor
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb

enum class Theme(
    val hex: String,
    val rgb: CSSColorValue
) {
    Primary(hex = "#89a8cb", rgb = rgb(r = 137, g = 168, b = 203)),

   // OpacityPrimary2(hex = "#89A8CBCC", rgb = argb(a=0.8f,r = 137, g = 168, b = 203)),
   // OpacityPrimary3(hex = "#89A8CBCC", rgb = argb(a=0.3f,r = 137, g = 168, b = 203)),

    OpacityPrimary2(
        hex = "#666E86A2",
        rgb = rgb(r = 110, g = 134, b = 162),
    ),

    OpacityPrimary3(
        hex = "#D0DCEA", // 40% opacity (alpha = 0x66)
        rgb = argb(a = 0.4f, r = 137, g = 168, b = 203),
    ),

    OpacityPrimary4(
        hex ="#E7EEF5", // 20% opacity (alpha = 0x33)
        rgb = argb(a = 0.2f, r = 137, g = 168, b = 203),
    ),
    WhiteOpacity80(
        hex = "#FFFFFF",
        rgb = argb(
            a = 0.8f,
            r = 255,
            g = 255,
            b = 255
        )
    ),

    Secondary(hex = "#121D34", rgb = rgb(r = 18, g = 29, b = 52)),
    Gray(hex = "#CFCFCF", rgb = rgb(r = 207, g = 207, b = 207)),
    LightGray(hex = "#EDEDED", rgb = rgb(r = 237, g = 237, b = 237)),
    DarkGrey(hex = "#F9F9F9", rgb = rgb(r = 36, g = 37, b = 43)),
    SemiGrey(hex = "#E3E3E3", rgb = rgb(160, 160, 160)),
    LighterGray(hex = "#F9F9F9", rgb = rgb(r = 249, g = 249, b = 249)),
    DarkPrimary(hex = "#89a8cb", rgb = rgb(r = 137, g = 168, b = 203)),
    DarkBlue(hex = "#00A78E", rgb = rgb(r = 29, g = 54, b = 92)),
    ShowcaseButton(hex = "#1D365C", rgb = rgb(r = 29, g = 54, b = 92)),
    ShowcaseButtonOpacity(hex = "#1D365C", rgb = argb(a=0.8f,r = 29, g = 54, b = 92)),
    FacebookColor(hex = "#1877F2", rgb = rgb(r = 24, g = 119, b = 242)),
    WhatsappColor(hex = "#25D366", rgb = rgb(r = 37, g = 211, b = 102)),
    BackgroundImage(hex = "#EDEAE3", rgb = rgb(r = 237, g = 234, b = 227)),

    MixSelection(hex = "#D4E8E6", rgb = rgb(r = 212, g = 232, b = 230)),

    BackgroundImage222(hex = "#EDEAE3", rgb = rgb(r = 251, g = 252, b = 246)),
    SectionBackground(hex = "#D1C189", rgb = rgb(254, 243, 199)),
    ImageBackground(hex = "#F0ECE6", rgb = rgb(r = 240, g = 236, b = 230)),
    CardBackground(hex = "#f5f7fb", rgb = rgb(r = 245, g = 247, b = 251)),

}
